// @generated by web/tools/codegen — DO NOT EDIT

import type { ListingsMode } from '@letsgethome/routes';

/**
 * The listings BROWSE surfaces — every route whose `web/manifests/routes.yaml`
 * row declares `browse: true`, and whose loader is therefore obliged to
 * state `browseScope` (webroutesgen's browse-scope obligation).
 */
export const BROWSE_ROUTE_IDS: ReadonlySet<string> = new Set([
  'district-detail/buy',
  'district-detail/rent',
  'listings/buy',
  'listings/buy-type',
  'listings/rent',
  'listings/rent-type',
]);

/** The primary nav's sections: the listings modes (`rent` / `buy`). */
export type NavSection = ListingsMode;

/**
 * The primary nav section the page at `routeId` (the LEAF route match)
 * belongs to: a browse surface is in the section of the mode its loader
 * stated, and every other page is in none.
 */
export function activeNavSection(
  routeId: string | undefined,
  browseScope: { readonly urlMode: ListingsMode } | null
): NavSection | null {
  if (routeId === undefined || !BROWSE_ROUTE_IDS.has(routeId)) return null;
  return browseScope?.urlMode ?? null;
}
